import { render, staticRenderFns } from "./VitaInvestimento.vue?vue&type=template&id=ebf2b3d2&"
import script from "./VitaInvestimento.vue?vue&type=script&lang=ts&"
export * from "./VitaInvestimento.vue?vue&type=script&lang=ts&"
import style0 from "./VitaInvestimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports